import React from 'react';

export const FormContext = React.createContext([]);

export const ClientContext = React.createContext([]);

export const SiderCollapsedContext = React.createContext([]);

export const AppSettingsContext = React.createContext([]);